export default {
    mounted() {
        if (this.$store.state.user) {
            this.getRoles();
        }
        this.$bus.$on('getRoles', this.getRoles);
    },
    beforeDestroy() {
        this.$bus.$off('getRoles');
    },
    methods: {
        getRoles() {
            this.$bgService.get('/role/', {params: {page: 1, pageSize: 100}}).then(response => {
                let roles = response.data.docs;
                this.$store.commit('roles', roles);
            });
        }
    }
}